// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__3z0iJ","name":"ConsentHeader_name__27ZQV","birthday":"ConsentHeader_birthday__1VzGs","skeleton":"ConsentHeader_skeleton__1SbXq"};